// extracted by mini-css-extract-plugin
export default {"menuIcon":"MenuIcon--menuIcon--5GGLR","bar":"MenuIcon--bar--8KEWf","isOpen":"MenuIcon--isOpen--PQydX"};